module.exports = __webpack_public_path__ + "static/media/echoes.a0435be8.jpg";